// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.48063 2.5H1V21H23V5H11.4806L9.48063 2.5ZM14.5 11.5C14.5 12.2402 14.1783 12.9052 13.6672 13.3629C15.0439 13.9951 16 15.3859 16 17V18H8V17C8 15.3859 8.95606 13.9951 10.3328 13.3629C9.82165 12.9052 9.5 12.2402 9.5 11.5C9.5 10.1193 10.6193 9 12 9C13.3807 9 14.5 10.1193 14.5 11.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-shared-filled')
export default class FolderSharedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-shared-filled',
    }
  }
}
